<template>
  <v-list
    v-if="carts.length"
    lines="two"
    density="comfortable"
  >
    <v-list-item
      v-for="cart in carts"
      :key="cart.id"
      :title="cart.name"
      :subtitle="cart.language?.descr ?? cart.language?.name"
    >
      <template #prepend>
        <v-avatar
          rounded
          size="56"
          class="me-4"
          :class="{ 'cursor-pointer': cart.image?.signed_file_url }"
          :role="cart.image?.signed_file_url ? 'button' : undefined"
          :tabindex="cart.image?.signed_file_url ? 0 : undefined"
          :aria-label="cart.image?.signed_file_url ? t('actions.show') : undefined"
          @click="enlarge(cart)"
          @keydown.enter="enlarge(cart)"
        >
          <v-img
            v-if="cart.image?.signed_file_url"
            :src="cart.image.signed_file_url"
            :alt="cart.name"
            cover
          />
          <v-icon
            v-else
            icon="fas fa-suitcase-rolling"
          />
        </v-avatar>
      </template>
    </v-list-item>
  </v-list>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    :fullscreen="xs"
  >
    <global-card
      :title="enlargedCart?.name"
      closable
      @close="dialog = false"
    >
      <v-img
        :src="enlargedCart?.image?.signed_file_url"
        :alt="enlargedCart?.name"
      />
      <template #actions>
        <v-btn
          :text="t('actions.close')"
          color="dark-grey"
          @click="dialog = false"
        />
      </template>
    </global-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';

defineProps<{
  carts: Array<App.Models.Cart>;
}>();

const { t } = useI18n();
const { xs } = useDisplay();
const dialog = ref(false);
const enlargedCart = ref<App.Models.Cart>();

function enlarge(cart: App.Models.Cart): void {
  if (!cart.image?.signed_file_url) {
    return;
  }
  enlargedCart.value = cart;
  dialog.value = true;
}
</script>
